import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const ReviewsModerationListView = lazy(() =>
	import('./components/views/ReviewsModerationListView').then((module) => ({
		default: module.ReviewsModerationListView
	}))
);

const reviewsRoutes: FuseRouteItemType[] = [
	{
		path: 'reviews',
		element: <ReviewsModerationListView />
	}
];

export default reviewsRoutes;
